import { render, staticRenderFns } from "./app-notification.vue?vue&type=template&id=011e756a&"
import script from "./app-notification.vue?vue&type=script&lang=js&"
export * from "./app-notification.vue?vue&type=script&lang=js&"
import style0 from "./app-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports